export default "__VITE_ASSET__DwzRv$ET__"